export default {
  characters: 'caracteres'
}

export const en = {
  characters: 'characters'
}

export const ca = {
  characters: 'caràcters'
}
